import { ascend, filter, isNil, map, prop, sort } from 'ramda';

import { GameStaticCategories } from './game';
import { CMSGroupMode } from '@/api/cms/base';
import { CMSGameCategory } from '@/api/cms/gameCategories';
import { GameCategory, SubGameCategory } from '@/api/games';
import { ImageComponent } from '@/components/Image';

const defineCategoryTitle = (id: string, title: string) => {
  if (id === GameStaticCategories.Favorites)
    return (
      <ImageComponent
        src="/emojis/heart.webp"
        alt="heart"
        width={24}
        height={24}
      />
    );
  else if (id === GameStaticCategories.Recent)
    return (
      <ImageComponent
        src="/emojis/clock.webp"
        alt="clock"
        width={24}
        height={24}
      />
    );

  return title;
};

export const filterCategoriesByBackEndIds = (
  backEndCategories: GameCategory[]
) =>
  filter<CMSGameCategory>(({ categoryId }) => {
    const backEndCategoryIds = backEndCategories.map(({ id }) => id);

    if (
      [
        GameStaticCategories.Favorites,
        GameStaticCategories.Lobby,
        GameStaticCategories.Recent,
      ].includes(categoryId as GameStaticCategories)
    )
      return true;

    return backEndCategoryIds.includes(categoryId);
  });

export const filterCategoriesByAuth = (isAuthenticated: boolean) =>
  filter(({ categoryId }: CMSGameCategory) =>
    [GameStaticCategories.Favorites, GameStaticCategories.Recent].includes(
      categoryId as GameStaticCategories
    )
      ? isAuthenticated
      : true
  );

export const formatCategories = (
  isAuthenticated: boolean,
  defaultCategories: GameCategory[]
) =>
  map(
    ({
      title,
      categoryIdAuth,
      categoryIdNotAuth,
      defaultCategoryId,
      order,
      groupsExcludeMode,
      groupsExclude,
      groupsInclude,
      groupsIncludeMode,
      subCategories,
      ...rest
    }: CMSGameCategory) => {
      const id = isAuthenticated ? categoryIdAuth : categoryIdNotAuth;

      const titleElement = defineCategoryTitle(id, title);

      const sortedSubCategories = sort<SubGameCategory>(ascend(prop('order')))(
        subCategories
      );

      return {
        ...rest,
        id,
        categoryIdAuth,
        categoryIdNotAuth,
        defaultCategoryId,
        title: titleElement,
        href:
          defaultCategoryId === GameStaticCategories.Lobby
            ? '/'
            : `/games/${defaultCategoryId}#gamesSection`,
        order: isNil(order) ? defaultCategories.length - 1 : order,
        groupsIncludeMode: groupsIncludeMode || CMSGroupMode.AND,
        groupsInclude: groupsInclude || null,
        groupsExcludeMode: groupsExcludeMode || CMSGroupMode.AND,
        groupsExclude: groupsExclude || null,
        subCategories: sortedSubCategories || [],
        gamesCount:
          defaultCategories.find((gameCategory) => gameCategory.id === id)
            ?.gamesCount ?? 0,
      };
    }
  );
